import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';

@Injectable({ providedIn: 'root' })
export class UserService {

    private subject = new BehaviorSubject<string>('Initial Value')
    current = this.subject.asObservable()

    private arrayData = new BehaviorSubject([])
    currentArray = this.arrayData.asObservable()

    constructor(
        private router: Router,
        private http: HttpClient
    ) { }

    sendData(data: any) {
        this.subject.next(data)
    }

    getData() {
        return this.current
    }

    sendArrayData(data: any) {
        this.arrayData.next(data)
    }


    // Apartment
    addApartment(name: any, address: any, email: any, contactNo1: any, countryCode1: any, contactNo2: any, countryCode2: any,
        ownerName: any, ownerContact: any, ownerCountryCode: any, latitude: any, longitude: any, username: any, password: any, trn: any, companyName: any,type: any, urwaCommissionRate: any, enabledServices: string[] = [], bannerImage?: File, communityPermissions: string[] = [], ownerId?: any) {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('ownerName', ownerName);
        formData.append('address', address);
        formData.append('username', username);
        formData.append('password', password);
        formData.append('contactNo1', contactNo1);
        formData.append('countryCode1', countryCode1);
        formData.append('contactNo2', contactNo2 || '');
        formData.append('countryCode2', countryCode2);
        formData.append('email', email);
        formData.append('ownerContact', ownerContact || '');
        formData.append('ownerCountryCode', ownerCountryCode);
        formData.append('latitude', latitude);
        formData.append('longitude', longitude);
        formData.append('trnNo', trn || '');
        formData.append('companyName', companyName || '');
        formData.append('type', type);
        formData.append('urwaCommissionRate', String(Number(urwaCommissionRate)));
        formData.append('enabledServices', JSON.stringify(enabledServices));
        // Community permissions (vehicles, daily-help, visitor-pass, etc.) —
        // only meaningful for residential apartments; other apartment types
        // just leave it as the default empty array.
        formData.append('communityPermissions', JSON.stringify(communityPermissions));
        // ownerId links to a master Owner record (see Owner CRUD) — only sent
        // by the residential apartment form, which picks an owner from a
        // dropdown instead of free-typing ownerName/ownerContact.
        if (ownerId) formData.append('ownerId', ownerId);
        if (bannerImage) formData.append('bannerImage', bannerImage);
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/add`, formData).pipe(map(user => {
            return user;
        }));
    }
    categoryDropdown(apartmentId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/category-dropdown?apartmentId=` + apartmentId).pipe(map(user => user));
    }
    updateApartment(id: any, name: any, address: any, email: any, contactNo1: any, countryCode1: any, contactNo2: any, countryCode2: any,
        ownerName: any, ownerContact: any, ownerCountryCode: any, latitude: any, longitude: any, username: any, trn: any, companyName: any,type: any, urwaCommissionRate: any, enabledServices: string[] = [], bannerImage?: File, communityPermissions: string[] = [], ownerId?: any) {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('ownerName', ownerName);
        formData.append('address', address);
        formData.append('username', username);
        formData.append('contactNo1', contactNo1);
        formData.append('countryCode1', countryCode1);
        formData.append('contactNo2', contactNo2 || '');
        formData.append('countryCode2', countryCode2);
        formData.append('email', email);
        formData.append('ownerContact', ownerContact || '');
        formData.append('ownerCountryCode', ownerCountryCode);
        formData.append('latitude', latitude);
        formData.append('longitude', longitude);
        formData.append('trnNo', trn || '');
        formData.append('companyName', companyName || '');
        formData.append('type', type);
        formData.append('urwaCommissionRate', String(Number(urwaCommissionRate)));
        formData.append('enabledServices', JSON.stringify(enabledServices));
        // Community permissions (vehicles, daily-help, visitor-pass, etc.) —
        // only meaningful for residential apartments; other apartment types
        // just leave it as the default empty array.
        formData.append('communityPermissions', JSON.stringify(communityPermissions));
        if (ownerId) formData.append('ownerId', ownerId);
        if (bannerImage) formData.append('bannerImage', bannerImage);
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    getapartmentlistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/getById/${id}`).pipe(map(user => user));
    }

    deleteApartment(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    getApartmentList(page: any, search: any, status: any, type: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/list?search=` + search + '&page=' + page + '&status=' + status + '&type=' + type).pipe(map(user => user));
    }

    // Unlock Packages (Find Apartment) — credit tiers residents will buy to unlock unit details.
    // Superadmin-only configuration; at most one tier per unitCount (3, 4 or 5).
    getUnlockPackageList(status?: any) {
        const query = status === undefined || status === null || status === '' ? '' : `?status=${status}`;
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/unlock-package/list${query}`).pipe(map(user => user));
    }

    getUnlockPackageById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/unlock-package/getById/${id}`).pipe(map(user => user));
    }

    addUnlockPackage(payload: { unitCount: number; price: number; currency?: string; creditValidityDays?: number | null }) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/unlock-package/create`, payload).pipe(map(user => user));
    }

    updateUnlockPackage(id: any, payload: { unitCount?: number; price?: number; currency?: string; creditValidityDays?: number | null; status?: 0 | 1 }) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/unlock-package/update/${id}`, payload).pipe(map(user => user));
    }

    deleteUnlockPackage(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/unlock-package/delete/${id}`).pipe(map(user => user));
    }
    apartmentDropdown(type?: any) {
        const url = `${environment.apiUrl}${environment.apiPrefix}/admin/apartment/dropdown` + (type ? `?type=${type}` : '');
        return this.http.get<any>(url).pipe(map(user => user));
    }

    blockApartment(id: any, status: any) {
        let formData =
        {
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/update-status/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }

    updatepassword(id: any, newPassword: any, confirmPassword: any) {
        var formData = {
            'newPassword': newPassword,
            'confirmPassword': confirmPassword
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/update-password/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    // Laundry
    getLaundrtList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }
    deleteLaundry(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    laundryDropdown(status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/dropdown?status=` + status).pipe(map(user => user));
    }
    getlaundrylistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/getById/${id}`).pipe(map(user => user));
    }
    addLaundry(
        name: any, email: any, phone1: any, countryCode1: any,
        phone2: any, countryCode2: any, address: any, ownerName: any,
        latitude: any, longitude: any, username: any, password: any,
        image: any, description: any, logoImage: any, trn: any, companyName: any, inHouse: any,
        deliveryChargeStatus: any, deliveryChargeType: any,
        deliveryPrice: any, deliveryCharges: any[], urwaCommissionRate: any, aiDescription: any = '',
        paymentMethods: any[] = ['online', 'offline'], onboardingId: string = ''
    ) {
        const formData = new FormData();
        if (onboardingId) formData.append('onboardingId', onboardingId);
        formData.append('name', name);
        formData.append('email', email);
        formData.append('phone1', phone1);
        formData.append('phone2', phone2);
        formData.append('countryCode1', countryCode1);
        formData.append('countryCode2', countryCode2);
        formData.append('address', address);
        formData.append('ownerName', ownerName);
        formData.append('username', username);
        formData.append('password', password);
        formData.append('description', description);
        formData.append('latitude', latitude);
        formData.append('longitude', longitude);
        formData.append('inHouse', inHouse);
        formData.append('trnNo', trn);
        formData.append('companyName', companyName);
        formData.append('deliveryChargeStatus', deliveryChargeStatus);
        formData.append('deliveryChargeType', deliveryChargeType);
        formData.append('deliveryPrice', deliveryPrice);
        formData.append('deliveryCharges', JSON.stringify(deliveryCharges));
        formData.append('urwaCommissionRate', String(Number(urwaCommissionRate)));
        formData.append('additionalInfo', aiDescription || '');
        formData.append('paymentMethods', JSON.stringify(paymentMethods));
        if (image) {
            formData.append('image', image, image.name);
        }
        if (logoImage) {
            formData.append('logoImage', logoImage, logoImage.name);
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateLaundry(
        id: any, name: any, email: any, phone1: any, countryCode1: any,
        phone2: any, countryCode2: any, address: any, ownerName: any,
        latitude: any, longitude: any, username: any, password: any,
        image: any, description: any, logoImage: any, trn: any, companyName: any, inHouse: any,
        deliveryChargeStatus: any, deliveryChargeType: any,
        deliveryPrice: any, deliveryCharges: any[], urwaCommissionRate: any, aiDescription: any = '',
        paymentMethods: any[] = ['online', 'offline']
    ) {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('email', email);
        formData.append('phone1', phone1);
        formData.append('phone2', phone2);
        formData.append('countryCode1', countryCode1);
        formData.append('countryCode2', countryCode2);
        formData.append('address', address);
        formData.append('ownerName', ownerName);
        formData.append('username', username);
        formData.append('password', password);
        formData.append('description', description);
        formData.append('latitude', latitude);
        formData.append('longitude', longitude);
        formData.append('inHouse', inHouse);
        formData.append('trnNo', trn);
        formData.append('companyName', companyName);
        formData.append('deliveryChargeStatus', deliveryChargeStatus);
        formData.append('deliveryChargeType', deliveryChargeType);
        formData.append('deliveryPrice', deliveryPrice);
        formData.append('deliveryCharges', JSON.stringify(deliveryCharges));
        formData.append('urwaCommissionRate', String(Number(urwaCommissionRate)));
        formData.append('additionalInfo', aiDescription || '');
        formData.append('paymentMethods', JSON.stringify(paymentMethods));
        if (image) {
            formData.append('image', image, image.name);
        }
        if (logoImage) {
            formData.append('logoImage', logoImage, logoImage.name);
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }
    blocklaundry(id: any, status: any) {
        let formData =
        {
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/update/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }

    updatelaundrypassword(id: any, newPassword: any, confirmPassword: any) {
        var formData = {
            'newPassword': newPassword,
            'confirmPassword': confirmPassword
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/update-password/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    // Restaurant 
    getrestaurantlist(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getrestaurantlistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/getById/` + id).pipe(map(user => user));
    }
    restaurantDropdown(status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/dropdown?status=` + status).pipe(map(user => user));
    }
    deleterestaurant(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    addRestaturant(name: any, owner_name: any, address: any, restaurant_type: any, description: any, secondary_description: any,
        username: any, password: any, mobile: any, countryCode1: any, mobile2: any, countryCode2: any, landline: any, owner_contact: any, ownerCountryCode: any, email: any, specialty1: any, specialty2: any,
        specialty3: any, latitude: any, longitude: any, inHouse: any, image: any, logoImage: any, trn: any, companyName: any, deliveryTime: any, breachTime: any, deliveryChargeStatus: any, deliveryChargeType: any,
        deliveryPrice: any, deliveryCharges: any[], urwaCommissionRate: any, aiDescription: any = '', paymentMethods: any[] = ['online', 'offline'], foodCategoryIds: string[] = [], onboardingId: string = '') {
        const formData = new FormData();
        if (onboardingId) formData.append('onboardingId', onboardingId);

        formData.append('name', name);
        formData.append('owner_name', owner_name);
        formData.append('address', address);
        formData.append('restaurant_type', restaurant_type);
        formData.append('description', description);
        formData.append('secondary_description', secondary_description);
        formData.append('username', username);
        formData.append('password', password);
        formData.append('mobile', mobile);
        formData.append('mobile2', mobile2);
        formData.append('countryCode', countryCode1);
        formData.append('countryCode2', countryCode2);
        formData.append('ownerCountryCode', ownerCountryCode);
        formData.append('landline', landline);
        formData.append('owner_contact', owner_contact);
        formData.append('email', email);
        formData.append('specialty1', specialty1);
        formData.append('specialty2', specialty2);
        formData.append('specialty3', specialty3);
        formData.append('latitude', latitude);
        formData.append('longitude', longitude);
        formData.append('inHouse', inHouse);
        formData.append('trnNo', trn);
        formData.append('companyName', companyName);
        formData.append('orderTime', deliveryTime);
        formData.append('breachTime', breachTime);
        formData.append('deliveryChargeStatus', deliveryChargeStatus);
        formData.append('deliveryChargeType', deliveryChargeType);
        formData.append('deliveryPrice', deliveryPrice);
        formData.append('deliveryCharges', JSON.stringify(deliveryCharges));
        formData.append('urwaCommissionRate', String(Number(urwaCommissionRate)));
        formData.append('additionalInfo', aiDescription || '');
        formData.append('paymentMethods', JSON.stringify(paymentMethods));
        formData.append('foodCategoryIds', JSON.stringify(foodCategoryIds));

        if (image) {
            formData.append('image', image, image.name);
        }
        if (logoImage) {
            formData.append('logoImage', logoImage, logoImage.name);
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateRestaturant(id: any, name: any, owner_name: any, address: any, restaurant_type: any, description: any, secondary_description: any,
        username: any, password: any, mobile: any, countryCode1: any, mobile2: any, countryCode2: any, landline: any, owner_contact: any, ownerCountryCode: any, email: any, specialty1: any, specialty2: any,
        specialty3: any, latitude: any, longitude: any, inHouse: any, image: any, logoImage: any, trn: any, companyName: any, deliveryTime: any, breachTime: any, deliveryChargeStatus: any, deliveryChargeType: any,
        deliveryPrice: any, deliveryCharges: any[], urwaCommissionRate: any, aiDescription: any = '', paymentMethods: any[] = ['online', 'offline'], foodCategoryIds: string[] = []) {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('owner_name', owner_name);
        formData.append('address', address);
        formData.append('restaurant_type', restaurant_type);
        formData.append('description', description);
        formData.append('secondary_description', secondary_description);
        formData.append('username', username);
        formData.append('password', password);
        formData.append('mobile', mobile);
        formData.append('mobile2', mobile2);
        formData.append('countryCode', countryCode1);
        formData.append('countryCode2', countryCode2);
        formData.append('ownerCountryCode', ownerCountryCode);
        formData.append('landline', landline);
        formData.append('owner_contact', owner_contact);
        formData.append('email', email);
        formData.append('specialty1', specialty1);
        formData.append('specialty2', specialty2);
        formData.append('specialty3', specialty3);
        formData.append('latitude', latitude);
        formData.append('longitude', longitude);
        formData.append('inHouse', inHouse);
        formData.append('trnNo', trn);
        formData.append('orderTime', deliveryTime);
        formData.append('breachTime', breachTime);
        formData.append('companyName', companyName);
        formData.append('deliveryChargeStatus', deliveryChargeStatus);
        formData.append('deliveryChargeType', deliveryChargeType);
        formData.append('deliveryPrice', deliveryPrice);
        formData.append('deliveryCharges', JSON.stringify(deliveryCharges));
        formData.append('urwaCommissionRate', String(Number(urwaCommissionRate)));
        formData.append('additionalInfo', aiDescription || '');
        formData.append('paymentMethods', JSON.stringify(paymentMethods));
        formData.append('foodCategoryIds', JSON.stringify(foodCategoryIds));

        if (image) {
            formData.append('image', image, image.name);
        }
        if (logoImage) {
            formData.append('logoImage', logoImage, logoImage.name);
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    updaterestaurantpassword(id: any, newPassword: any, confirmPassword: any) {
        var formData = {
            'newPassword': newPassword,
            'confirmPassword': confirmPassword
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/update-password/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    blockrestaurant(id: any, status: any) {
        let formData =
        {
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/update/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }

    getgrocerylist(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/grocery/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getgrocerylistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/grocery/getById/` + id).pipe(map(user => user));
    }

    grocerydropdown(status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/grocery/dropdown?status=` + status).pipe(map(user => user));
    }

    deletegrocery(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/grocery/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }

    private buildGroceryFormData(payload: any, image: any, logoImage: any): FormData {
        const formData = new FormData();
        formData.append('name', payload.name);
        formData.append('description', payload.description);
        formData.append('secondary_description', payload.secondary_description || '');
        formData.append('tagline', payload.tagline || '');
        formData.append('email', payload.email);
        formData.append('mobile', payload.mobile);
        formData.append('countryCode', payload.countryCode);
        formData.append('mobile2', payload.mobile2 || '');
        formData.append('countryCode2', payload.countryCode2 || '');
        formData.append('landline', payload.landline || '');
        formData.append('owner_name', payload.owner_name);
        formData.append('owner_contact', payload.owner_contact || '');
        formData.append('ownerCountryCode', payload.ownerCountryCode || '');
        formData.append('address', JSON.stringify(payload.address || {}));
        formData.append('websiteLink', payload.websiteLink || '');
        formData.append('latitude', payload.latitude);
        formData.append('longitude', payload.longitude);
        formData.append('weeklyTiming', JSON.stringify(payload.weeklyTiming || []));
        formData.append('inHouse', payload.inHouse);
        formData.append('trnNo', payload.trnNo || '');
        formData.append('companyName', payload.companyName || '');
        formData.append('urwaCommissionRate', String(Number(payload.urwaCommissionRate)));
        formData.append('paymentMethods', JSON.stringify(payload.paymentMethods || ['online', 'offline']));
        formData.append('additionalInfo', payload.additionalInfo || '');
        formData.append('catalogIntegration', payload.catalogIntegration || 'manual');
        formData.append('username', payload.username);
        formData.append('deliveryChargeStatus', payload.deliveryChargeStatus);
        formData.append('deliveryChargeType', payload.deliveryChargeType);
        formData.append('deliveryPrice', payload.deliveryPrice);
        formData.append('deliveryCharges', JSON.stringify(payload.deliveryCharges || []));
        formData.append('smallCartFee', payload.smallCartFee ?? 0);
        formData.append('smallCartThreshold', payload.smallCartThreshold ?? 0);
        if (payload.password) {
            formData.append('password', payload.password);
        }
        if (image) {
            formData.append('image', image, image.name);
        }
        if (logoImage) {
            formData.append('logoImage', logoImage, logoImage.name);
        }
        if (payload.chatEnabled !== undefined) formData.append('chatEnabled', String(payload.chatEnabled));
        if (payload.onboardingId) formData.append('onboardingId', payload.onboardingId);
        return formData;
    }

    addGrocery(payload: any, image: any, logoImage: any) {
        const formData = this.buildGroceryFormData(payload, image, logoImage);
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/grocery/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateGrocery(id: any, payload: any, image: any, logoImage: any) {
        const formData = this.buildGroceryFormData(payload, image, logoImage);
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/grocery/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    updategrocerypassword(id: any, newPassword: any, confirmPassword: any) {
        var formData = {
            'newPassword': newPassword,
            'confirmPassword': confirmPassword
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/grocery/update-password/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    blockgrocery(id: any, status: any) {
        let formData =
        {
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/grocery/update/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }

    //club category 
    getClubCategoryList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/club/category/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getclubcategoryId(id: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/club/category/view/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    getClubDropdown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/club/category/dropdown`).pipe(map(user => user));
    }

    addclubcategory(name: any) {
        const formData = {
            name: name,
        }
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/club/category/add`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    updateclubcategory(id: any, name: any, status: any) {
        const formData = {
            name: name,
            status: status
        }
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/club/category/update/` + id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    deleteClubCategory(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/club/category/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }

    //club
    getClubList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/club/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    clubDropdown(status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/club/dropdown?status=` + status).pipe(map(user => user));
    }


    getClubById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/club/getById/` + id).pipe(map(user => user));
    }

    deleteClub(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/club/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }

    blockClub(id: any, status: any) {
        let formData =
        {
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/club/updateStatus/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }

    updateClubPassword(id: any, newPassword: any, confirmPassword: any) {
        var formData = {
            'newPassword': newPassword,
            'confirmPassword': confirmPassword
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/club/update-password/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    addClub(clubData: any) {
        const formData = new FormData();
        // ===== Basic Information =====
        formData.append('name', clubData.clubName);
        formData.append('tagline', clubData.clubTagline);
        formData.append('clubDescription', clubData.clubDescription);
        formData.append('mobile', clubData.contactNumber1);
        formData.append('mobile2', clubData.contactNumber2);
        formData.append('email', clubData.email);
        formData.append('website', clubData.website);
        formData.append('socialMediaLinks', JSON.stringify(clubData.socialMediaLinks));
        formData.append('address', clubData.fullAddress);
        formData.append('city', clubData.city);
        formData.append('state', clubData.state);
        formData.append('pincode', clubData.pincode);
        formData.append('latitude', clubData.latitude);
        formData.append('longitude', clubData.longitude);

        // ===== Category =====
        formData.append('category', clubData.clubCategory);
        formData.append('expence', clubData.expenseCategory);

        // ===== Policies & Details =====
        formData.append('timings', JSON.stringify(clubData.timings));
        formData.append('entryPolicy', clubData.entryPolicy);
        formData.append('ageRestriction', clubData.ageRestriction);
        formData.append('idProofRequired', clubData.idProofRequired);
        formData.append('stagEntryPolicy', clubData.stagEntryPolicy);
        formData.append('coupleEntryPolicy', clubData.coupleEntryPolicy);
        formData.append('coverCharges', clubData.coverCharges);
        formData.append('refundPolicy', clubData.refundPolicy);
        formData.append('photographyPolicy', clubData.photographyPolicy);
        formData.append('dressCode', clubData.dressCode);
        formData.append('facilities', JSON.stringify(clubData.facilities));

        // ===== Credentials =====
        formData.append('username', clubData.username);
        formData.append('password', clubData.password);

        // ===== Files =====
        if (clubData.clubLogo) {
            formData.append('logoImage', clubData.clubLogo);
        }

        if (clubData.bannerImage) {
            formData.append('image', clubData.bannerImage);
        }

        if (clubData.imageGallery?.length) {
            clubData.imageGallery.forEach((img: File) => {
                formData.append('imageGallery', img);
            });
        }

        if (clubData.promoVideo) {
            formData.append('promoVideo', clubData.promoVideo);
        }

        if (clubData.menuPdf) {
            formData.append('menuPdf', clubData.menuPdf);
        }

        return this.http.post<any>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/club/add`,
            clubData
        );
    }

    updateClub(id: any, clubData: any) {
        const formData = new FormData();
        Object.keys(clubData).forEach(key => {
            if (
                clubData[key] !== undefined &&
                clubData[key] !== null &&
                !['imageGallery', 'clubLogo', 'bannerImage', 'promoVideo', 'menuPdf'].includes(key)
            ) {
                if (typeof clubData[key] === 'object') {
                    formData.append(key, JSON.stringify(clubData[key]));
                } else {
                    formData.append(key, clubData[key]);
                }
            }
        });

        // ===== Files (Optional on Update) =====
        if (clubData.clubLogo) {
            formData.append('clubLogo', clubData.clubLogo);
        }

        if (clubData.bannerImage) {
            formData.append('bannerImage', clubData.bannerImage);
        }

        if (clubData.imageGallery?.length) {
            clubData.imageGallery.forEach((img: File) => {
                formData.append('imageGallery', img);
            });
        }

        if (clubData.promoVideo) {
            formData.append('promoVideo', clubData.promoVideo);
        }

        if (clubData.menuPdf) {
            formData.append('menuPdf', clubData.menuPdf);
        }

        return this.http.put<any>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/club/update/${id}`,
            clubData
        );
    }

    //spa Category
    getSpaCategoryList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/spa/category/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getSpacategoryId(id: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/spa/category/view/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    getSpaDropdown(search = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/spa/dropdown?search=${search}`).pipe(map(user => user));
    }

    getGroceryDropdown(status: any = 1) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/grocery/dropdown?status=${status}`).pipe(map(user => user));
    }

  
    getCarRentalList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/car-rental/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getCarRentalById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/car-rental/getById/` + id).pipe(map(user => user));
    }

    getCarRentalDropdown(status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/car-rental/dropdown?status=` + status).pipe(map(user => user));
    }

    deleteCarRental(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/car-rental/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }

    private buildCarRentalFormData(payload: any, image: any, logoImage: any): FormData {
        const formData = new FormData();
        formData.append('name', payload.name);
        formData.append('description', payload.description);
        formData.append('secondary_description', payload.secondary_description || '');
        formData.append('tagline', payload.tagline || '');
        formData.append('email', payload.email);
        formData.append('mobile', payload.mobile);
        formData.append('countryCode', payload.countryCode);
        formData.append('mobile2', payload.mobile2 || '');
        formData.append('countryCode2', payload.countryCode2 || '');
        formData.append('landline', payload.landline || '');
        formData.append('owner_name', payload.owner_name);
        formData.append('owner_contact', payload.owner_contact || '');
        formData.append('ownerCountryCode', payload.ownerCountryCode || '');
        formData.append('address', JSON.stringify(payload.address || {}));
        formData.append('websiteLink', payload.websiteLink || '');
        formData.append('latitude', payload.latitude);
        formData.append('longitude', payload.longitude);
        formData.append('weeklyTiming', JSON.stringify(payload.weeklyTiming || []));
        formData.append('trnNo', payload.trnNo || '');
        formData.append('companyName', payload.companyName || '');
        formData.append('urwaCommissionRate', String(Number(payload.urwaCommissionRate)));
        formData.append('paymentMethods', JSON.stringify(payload.paymentMethods || ['online', 'offline']));
        formData.append('additionalInfo', payload.additionalInfo || '');
        formData.append('catalogIntegration', payload.catalogIntegration || 'manual');
        if (payload.minDriverAge !== undefined && payload.minDriverAge !== null && payload.minDriverAge !== '') {
            formData.append('minDriverAge', String(payload.minDriverAge));
        }
        formData.append('securityDeposit', String(Number(payload.securityDeposit) || 0));
        formData.append('username', payload.username);
        if (payload.password) {
            formData.append('password', payload.password);
        }
        if (image) {
            formData.append('image', image, image.name);
        }
        if (logoImage) {
            formData.append('logoImage', logoImage, logoImage.name);
        }
        if (payload.chatEnabled !== undefined) formData.append('chatEnabled', String(payload.chatEnabled));
        if (payload.onboardingId) formData.append('onboardingId', payload.onboardingId);
        return formData;
    }

    addCarRental(payload: any, image: any, logoImage: any) {
        const formData = this.buildCarRentalFormData(payload, image, logoImage);
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/car-rental/add`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateCarRental(id: any, payload: any, image: any, logoImage: any) {
        const formData = this.buildCarRentalFormData(payload, image, logoImage);
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/car-rental/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateCarRentalPassword(id: any, newPassword: any, confirmPassword: any) {
        var formData = {
            'newPassword': newPassword,
            'confirmPassword': confirmPassword
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/car-rental/update-password/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    blockCarRental(id: any, status: any) {
        let formData =
        {
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/car-rental/update/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }

    // Adventure vendors. Every write except the password reset is mirrored to UMP;
    // a failed mirror is rolled back and comes back as 502.
    getAdventureList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/adventure/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getAdventureById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/adventure/getById/` + id).pipe(map(user => user));
    }

    getAdventureDropdown(status: any = 1) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/adventure/dropdown?status=` + status).pipe(map(user => user));
    }

    deleteAdventure(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/adventure/delete/` + id).pipe(map(user => user));
    }

    private buildAdventureFormData(payload: any, image: any, logoImage: any): FormData {
        const formData = new FormData();
        formData.append('name', payload.name);
        formData.append('description', payload.description);
        formData.append('secondary_description', payload.secondary_description || '');
        formData.append('tagline', payload.tagline || '');
        formData.append('email', payload.email || '');
        formData.append('mobile', payload.mobile);
        formData.append('countryCode', payload.countryCode);
        formData.append('mobile2', payload.mobile2 || '');
        formData.append('countryCode2', payload.countryCode2 || '');
        formData.append('landline', payload.landline || '');
        formData.append('owner_name', payload.owner_name || '');
        formData.append('owner_contact', payload.owner_contact || '');
        formData.append('ownerCountryCode', payload.ownerCountryCode || '');
        formData.append('address', JSON.stringify(payload.address || {}));
        formData.append('websiteLink', payload.websiteLink || '');
        formData.append('latitude', payload.latitude);
        formData.append('longitude', payload.longitude);
        formData.append('weeklyTiming', JSON.stringify(payload.weeklyTiming || []));
        formData.append('trnNo', payload.trnNo || '');
        formData.append('companyName', payload.companyName || '');
        formData.append('urwaCommissionRate', String(Number(payload.urwaCommissionRate)));
        formData.append('paymentMethods', JSON.stringify(payload.paymentMethods || ['online', 'offline']));
        formData.append('additionalInfo', payload.additionalInfo || '');
        formData.append('catalogIntegration', payload.catalogIntegration || 'manual');
        formData.append('securityDeposit', String(Number(payload.securityDeposit) || 0));
        formData.append('username', payload.username);
        if (payload.slug) {
            formData.append('slug', payload.slug);
        }
        if (payload.password) {
            formData.append('password', payload.password);
        }
        if (image) {
            formData.append('image', image, image.name);
        }
        if (logoImage) {
            formData.append('logoImage', logoImage, logoImage.name);
        }
        if (payload.chatEnabled !== undefined) formData.append('chatEnabled', String(payload.chatEnabled));
        if (payload.onboardingId) formData.append('onboardingId', payload.onboardingId);
        return formData;
    }

    addAdventure(payload: any, image: any, logoImage: any) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/adventure/add`, this.buildAdventureFormData(payload, image, logoImage)).pipe(map(user => user));
    }

    updateAdventure(id: any, payload: any, image: any, logoImage: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/adventure/update/${id}`, this.buildAdventureFormData(payload, image, logoImage)).pipe(map(user => user));
    }

    updateAdventureStatus(id: any, status: number) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/adventure/updateStatus/` + id, { status }).pipe(map(user => user));
    }

    updateAdventurePassword(id: any, newPassword: any, confirmPassword: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/adventure/update-password/` + id, { newPassword, confirmPassword }).pipe(map(user => user));
    }

    addSpacategory(name: any) {
        const formData = {
            name: name,
        }
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/spa/category/add`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    updateSpacategory(id: any, name: any, status: any) {
        const formData = {
            name: name,
            status: status
        }
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/spa/category/update/` + id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    deleteSpaCategory(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/spa/category/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }

    //Spa
    private buildSpaFormData(payload: any, image: any, logoImage: any, galleryImages?: any[], removeGalleryImages?: string[]): FormData {
        const formData = new FormData();
        formData.append('name', payload.name);
        formData.append('description', payload.description);
        formData.append('secondary_description', payload.secondary_description || '');
        formData.append('tagline', payload.tagline || '');
        formData.append('email', payload.email || '');
        formData.append('mobile', payload.mobile);
        formData.append('countryCode', payload.countryCode);
        formData.append('mobile2', payload.mobile2 || '');
        formData.append('countryCode2', payload.countryCode2 || '');
        formData.append('landline', payload.landline || '');
        formData.append('owner_name', payload.owner_name || '');
        formData.append('owner_contact', payload.owner_contact || '');
        formData.append('ownerCountryCode', payload.ownerCountryCode || '');
        formData.append('address', JSON.stringify(payload.address || {}));
        formData.append('websiteLink', payload.websiteLink || '');
        formData.append('latitude', payload.latitude);
        formData.append('longitude', payload.longitude);
        formData.append('weeklyTiming', JSON.stringify(payload.weeklyTiming || []));
        formData.append('spaType', JSON.stringify(payload.spaType || []));
        formData.append('trnNo', payload.trnNo || '');
        formData.append('companyName', payload.companyName || '');
        formData.append('urwaCommissionRate', String(Number(payload.urwaCommissionRate ?? 20)));
        formData.append('paymentMethods', JSON.stringify(payload.paymentMethods || ['offline']));
        formData.append('additionalInfo', payload.additionalInfo || '');
        formData.append('catalogIntegration', payload.catalogIntegration || 'manual');
        formData.append('username', payload.username);
        if (payload.expence) {
            formData.append('expence', payload.expence);
        }
        if (payload.facilities) {
            formData.append('facilities', payload.facilities);
        }
        if (payload.slug) {
            formData.append('slug', payload.slug);
        }
        if (payload.password) {
            formData.append('password', payload.password);
        }
        if (image) {
            formData.append('image', image, image.name);
        }
        if (logoImage) {
            formData.append('logoImage', logoImage, logoImage.name);
        }
        if (galleryImages && galleryImages.length) {
            for (let i = 0; i < galleryImages.length; i++) {
                formData.append('imageGallery', galleryImages[i], galleryImages[i].name);
            }
        }
        if (removeGalleryImages && removeGalleryImages.length) {
            formData.append('removeGalleryImages', JSON.stringify(removeGalleryImages));
        }
        if (payload.chatEnabled !== undefined) formData.append('chatEnabled', String(payload.chatEnabled));
        if (payload.onboardingId) formData.append('onboardingId', payload.onboardingId);
        return formData;
    }

    getSpaList(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/spa/list?search=` + search + '&page=' + page + '&status=' + status).pipe(map(user => user));
    }

    getSpaById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/spa/getById/` + id).pipe(map(user => user));
    }

    deleteSpa(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/spa/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }

    blockSpa(id: any, status: any) {
        let formData =
        {
            status: status
        }
        return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/spa/updateStatus/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }

    updateSpaPassword(id: any, newPassword: any, confirmPassword: any) {
        var formData = {
            'newPassword': newPassword,
            'confirmPassword': confirmPassword
        }
        return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/spa/update-password/` + id, formData).pipe(map(user => {
            return user;
        }));
    }

    addSpa(payload: any, image?: any, logoImage?: any, galleryImages?: any[]) {
        const formData = payload instanceof FormData ? payload : this.buildSpaFormData(payload, image, logoImage, galleryImages);
        return this.http.post<any>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/spa/add`,
            formData
        ).pipe(map(user => user));
    }

    updateSpa(id: any, payload: any, image?: any, logoImage?: any, galleryImages?: any[], removeGalleryImages?: string[]) {
        const formData = payload instanceof FormData ? payload : this.buildSpaFormData(payload, image, logoImage, galleryImages, removeGalleryImages);
        return this.http.patch<any>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/spa/update/${id}`,
            formData
        ).pipe(map(user => user));
    }


    // upload banner
    getbannerimage() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/list-image`).pipe(map(user => user));
    }
    uploadBannerImage(key: any, mainImages: any, subImages1: any, subImages2: any) {
        const formData: FormData = new FormData();
        formData.append('key', key)
        if (mainImages) {
            formData.append('mainImages', mainImages, mainImages.name);
        }
        if (subImages1) {
            formData.append('subImages1', subImages1, subImages1.name);
        }
        if (subImages2) {
            formData.append('subImages2', subImages2, subImages2.name);
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/upload-images`, formData).pipe(map(user => {
            return user;
        }));
    }

    updateBannerImage(key: any, imagePath: any, file: any) {
        const formData: FormData = new FormData();
        formData.append('key', key)
        formData.append('imagePath', imagePath)
        if (file) {
            formData.append('file', file, file.name);
        }

        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/update-image`, formData).pipe(map(user => {
            return user;
        }));
    }

    // deleteBannerImage(id: any) {
    //     return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/deletebanner/` + id).pipe(map(user => {
    //         return user;
    //     }));
    // }
    deleteBannerImage(payload: { key: string; imagePath: string }): Observable<any> {
        const options = {
            body: payload
        };

        return this.http.request<any>('DELETE', `${environment.apiUrl}${environment.apiPrefix}/admin/apartment/delete-image`, options).pipe(map(response => {
            return response;
        }));
    }

    getResidentialBannerImages() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/residential-banner/list`).pipe(map(user => user));
    }

    uploadResidentialBannerImage(file: any, apartmentId: string | null) {
        const formData: FormData = new FormData();
        formData.append('image', file, file.name);
        if (apartmentId) {
            formData.append('apartmentId', apartmentId);
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/residential-banner/upload`, formData).pipe(map(user => user));
    }

    updateResidentialBannerImage(imagePath: string, file: any, apartmentId: string | null) {
        const formData: FormData = new FormData();
        formData.append('imagePath', imagePath);
        formData.append('file', file, file.name);
        if (apartmentId) {
            formData.append('apartmentId', apartmentId);
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/residential-banner/update`, formData).pipe(map(user => user));
    }

    deleteResidentialBannerImage(imagePath: string): Observable<any> {
        return this.http.request<any>('DELETE', `${environment.apiUrl}${environment.apiPrefix}/admin/residential-banner/delete`, { body: { imagePath } }).pipe(map(user => user));
    }

    // Ad (Residential Banner) APIs
    adList(page: number = 1, limit: number = 10) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/ad/list?page=${page}&limit=${limit}`).pipe(map(r => r));
    }

    adGetById(id: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/ad/getById/${id}`).pipe(map(r => r));
    }

    adCreate(placement: string, apartmentIds: string[], file: File, externalLink?: string) {
        const fd = new FormData();
        fd.append('placement', placement);
        fd.append('image', file, file.name);
        fd.append('apartmentId', JSON.stringify(apartmentIds));
        if (externalLink) fd.append('externalLink', externalLink);
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/ad/create`, fd).pipe(map(r => r));
    }

    adUpdate(id: string, placement: string, apartmentIds: string[], file?: File, externalLink?: string) {
        const fd = new FormData();
        fd.append('placement', placement);
        fd.append('apartmentId', JSON.stringify(apartmentIds));
        if (file) fd.append('image', file, file.name);
        fd.append('externalLink', externalLink || '');
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/ad/update/${id}`, fd).pipe(map(r => r));
    }

    adDelete(id: string) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/ad/delete/${id}`).pipe(map(r => r));
    }

    // Settings
    getAssignLists(page: any, search: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/assign-list?search=` + search + '&page=' + page).pipe(map(user => user));
    }

    assignServicesToApartment(assignedData: any) {
        return this.http.put<any>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/apartment/assign`,
            assignedData
        ).pipe(
            map(response => response)
        );
    }

    directLogin(id: any, type: any) {
        let formData =
        {
            username: id,
            type: type
        }
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/direct-login`, formData)
            .pipe(map((user) => { return user; }));
    }


    // Qr-code
    createQrCode() {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/qr-code/create`, '').pipe(map(user => {
            return user;
        }));
    }
    deleteQrCode(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/qr-code/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    ViewQrCode() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/qr-code/view`).pipe(map(user => user));
    }

    //Dashboard
    getDashboardCountList(startDate: any, endDate: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/states?startDate=` + startDate + '&endDate=' + endDate).pipe(map(user => user));
    }

    getDashboardChartList(startDate: any, endDate: any, apartmentId: any, vendorId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/chart?startDate=` + startDate + '&endDate=' + endDate + '&apartmentId=' + apartmentId + '&vendorId=' + vendorId).pipe(map(user => user));
    }

    getDashboardLaundryStates(apartmentId: any, vendorId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/laundryStates?apartmentId=` + apartmentId + '&vendorId=' + vendorId).pipe(map(user => user));
    }

    getDashboardRoomServiceStates(apartmentId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/roomServiceStates?apartmentId=` + apartmentId).pipe(map(user => user));
    }
    getDashboardRestaurantStates(apartmentId: any, vendorId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/restaurantStates?apartmentId=` + apartmentId + '&vendorId=' + vendorId).pipe(map(user => user));
    }

    private buildDashboardParams(f: { days?: number; startDate?: string; endDate?: string; type?: string; apartmentId?: string; vendorId?: string }): string {
        let q = '';
        if (f.startDate) q += `&startDate=${f.startDate}`;
        if (f.endDate)   q += `&endDate=${f.endDate}`;
        if (f.days)      q += `&days=${f.days}`;
        if (f.type)      q += `&type=${f.type}`;
        if (f.apartmentId) q += `&apartmentId=${f.apartmentId}`;
        if (f.vendorId)    q += `&vendorId=${f.vendorId}`;
        return q;
    }

    getDashboardMonthlyStats(f: { days?: number; type?: string; apartmentId?: string; vendorId?: string } = {}) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/monthly-stats?${this.buildDashboardParams(f)}`).pipe(map(user => user));
    }

    // v2 reads from the unified allOrders collection instead of fanning out
    // across per-service collections. Same params/shape as v1 — see
    // DashboardComponent.useDashboardV2 for the on/off switch.
    getDashboardMonthlyStatsV2(f: { days?: number; type?: string; apartmentId?: string; vendorId?: string } = {}) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/monthly-stats-v2?${this.buildDashboardParams(f)}`).pipe(map(user => user));
    }

    getDashboardRevenue(f: { days?: number; type?: string; apartmentId?: string; vendorId?: string } = {}) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/revenue-chart?${this.buildDashboardParams(f)}`).pipe(map(user => user));
    }

    markVendorSettlementPaid(payload: { fromDate: string; toDate: string; vendorType: string; vendorId: string; paymentReference: string }): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/mark-paid`, payload);
    }

    getDashboardRevenueBreakdown(f: { days?: number; type?: string; apartmentId?: string; vendorId?: string } = {}) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/revenue-breakdown?${this.buildDashboardParams(f)}`).pipe(map(user => user));
    }

    getDashboardOrderBreakdown(f: { days?: number; type?: string; apartmentId?: string; vendorId?: string } = {}) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/order-breakdown?${this.buildDashboardParams(f)}`).pipe(map(user => user));
    }

    getDashboardUserBreakdown(f: { days?: number; type?: string; apartmentId?: string; vendorId?: string } = {}) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/user-breakdown?${this.buildDashboardParams(f)}`).pipe(map(user => user));
    }

    getDashboardPaymentModeStats(f: { days?: number; type?: string; apartmentId?: string; vendorId?: string } = {}) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/payment-mode-stats?${this.buildDashboardParams(f)}`).pipe(map(res => res));
    }

    getDashboardSlaBreakdown(f: { days?: number; type?: string; apartmentId?: string; vendorId?: string } = {}) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/sla-breakdown?${this.buildDashboardParams(f)}`).pipe(map(res => res));
    }

    getDashboardVendors(search: string = ''): Observable<any> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/vendors?page=1&limit=100`;
        if (search) url += `&search=${search}`;
        return this.http.get<any>(url);
    }

    getDashboardOrders(page: any, search: any, dateFilter = 'today', orderStatus = '', apartmentId = '', serviceType = '', paymentType = '', fromDate = '', toDate = '') {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/lifecycle?page=${page}&search=${search}&dateFilter=${dateFilter}&orderStatus=${orderStatus}&apartmentId=${apartmentId}&serviceType=${serviceType}&paymentType=${paymentType}`;
        // Only sent for dateFilter === 'custom' — same fromDate/toDate shape
        // the other order-list endpoints (getAllOrderLists etc.) already use.
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;
        return this.http.get<any>(url).pipe(map(user => user));
    }

    // v2 counterpart of getDashboardOrders — same params plus an explicit
    // limit; reads from the unified allOrders collection. See
    // DashboardComponent.useDashboardV2 for the on/off switch.
    getDashboardOrdersV2(page: any, search: any, dateFilter = 'today', orderStatus = '', apartmentId = '', serviceType = '', paymentType = '', fromDate = '', toDate = '', limit: any = 10) {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/lifecycle-v2?page=${page}&limit=${limit}&search=${search}&dateFilter=${dateFilter}&orderStatus=${orderStatus}&apartmentId=${apartmentId}&serviceType=${serviceType}&paymentType=${paymentType}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;
        return this.http.get<any>(url).pipe(map(user => user));
    }

    // order details
    getAllOrderLists(search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, fromDate: any, toDate: any, apartmentId: any, orderStatus: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/allOrders/list?search_invoiceNumber=` + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId + '&orderStatus=' + orderStatus).pipe(map(user => user));
    }
    getLaundryOrderLists(search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, orderStatus: any, fromDate: any, toDate: any, apartmentId: any, laundryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/laundry/list?search_invoiceNumber=` + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&orderStatus=' + orderStatus + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId + '&laundryId=' + laundryId).pipe(map(user => user));
    }
    getLaundryCount() {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/orders/laundry/count`
            )
            .pipe(map((user) => user));
    }
    getLaundryorderById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/laundry/viewById?id=` + id).pipe(map(user => user));
    }

    // Room

    getRoomOrderLists(search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, orderStatus: any, fromDate: any, toDate: any, apartmentId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/roomService/list?search_invoiceNumber=` + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&orderStatus=' + orderStatus + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId).pipe(map(user => user));
    }
    getRoomCount() {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/orders/roomService/count`
            )
            .pipe(map((user) => user));
    }
    getRoomorderById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/laundry/viewById?id=` + id).pipe(map(user => user));
    }

    // Residential Service

    getResidentialOrderList(search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, orderStatus: any, fromDate: any, toDate: any, apartmentId: any, paidStatus: any = '') {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/orders/residentialService/list?search_invoiceNumber=` + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&orderStatus=' + orderStatus + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId;
        if (paidStatus !== '') url += '&paidStatus=' + paidStatus;
        return this.http.get<any>(url).pipe(map(user => user));
    }

    getResidentialOrderCount() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/residentialService/count`).pipe(map(user => user));
    }

    getResidentialOrderById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/residentialService/viewById/` + id).pipe(map(user => user));
    }

    // Club

    getClubOrderList(search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, orderStatus: any, fromDate: any, toDate: any, apartmentId: any, clubId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/club/booking/list?search_invoiceNumber=` + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&orderStatus=' + orderStatus + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId + '&clubId=' + clubId).pipe(map(user => user));
    }

    getClubOrderCount() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/club/booking/count`).pipe(map(user => user));
    }

    getClubOrderById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/club/booking/view/` + id).pipe(map(user => user));
    }

    // Grocery

    getGroceryOrderList(search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, orderStatus: any, fromDate: any, toDate: any, apartmentId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/grocery/list?search_invoiceNumber=` + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&orderStatus=' + orderStatus + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId).pipe(map(user => user));
    }

    getGroceryOrderCount() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/grocery/count`).pipe(map(user => user));
    }

    getGroceryOrderById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/grocery/viewById/` + id).pipe(map(user => user));
    }

    // Car Rental

    getCarRentalOrderList(search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, orderStatus: any, fromDate: any, toDate: any, apartmentId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/carRental/list?search_invoiceNumber=` + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&orderStatus=' + orderStatus + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId).pipe(map(user => user));
    }

    getCarRentalOrderCount() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/carRental/count`).pipe(map(user => user));
    }

    getCarRentalOrderById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/carRental/viewById/` + id).pipe(map(user => user));
    }

    // Food

    getFoodOrderLists(search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, orderStatus: any, fromDate: any, toDate: any, apartmentId: any, restaurant_id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/restaurant/list?search_invoiceNumber=` + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&orderStatus=' + orderStatus + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId + '&restaurant_id=' + restaurant_id).pipe(map(user => user));
    }
    getFoodCount() {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/orders/restaurant/count`
            )
            .pipe(map((user) => user));
    }
    getFoodById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/restaurant/viewById/` + id).pipe(map(user => user));
    }

    // Additional order
    getAdditionalOrderLists(search_invoiceNumber: any, search_userName: any, search_userContactNo: any, search_userEmail: any, page: any, orderStatus: any, fromDate: any, toDate: any, apartmentId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/additional-roomService/list?search_invoiceNumber=` + search_invoiceNumber + '&search_userName=' + search_userName + '&search_userContactNo=' + search_userContactNo + '&search_userEmail=' + search_userEmail + '&page=' + page + '&orderStatus=' + orderStatus + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId).pipe(map(user => user));
    }
    getAdditionalCount() {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/orders/additional-roomService/count`
            )
            .pipe(map((user) => user));
    }
    getAdditiobalById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/additional-roomService/viewById/` + id).pipe(map(user => user));
    }

    //bill to desk
    getBillToDesk(search: any, page: any, fromDate: any, toDate: any, apartmentId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/billToDesk/list?search=` + search + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate + '&apartmentId=' + apartmentId).pipe(map(user => user));
    }

    paidStatusUpdate(id: any) {
        var formData = {
            'parentId': id,
        }
        return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/orders/billToDesk/paidStatusUpdate`, formData).pipe(map(user => {
            return user;
        }));
    }


    // Staff Creation
    getStaffUsers(page: any, search: any, status: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/list?page=` +
                page +
                "&search=" +
                search +
                "&status=" +
                status
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    createStaff(name: any, username: any, password: any, permissions: any, roleId: string = '') {
        const formData: any = {
            name: name,
            username: username,
            password: password,
            permissions: permissions,
        };
        if (roleId) formData.roleId = roleId;
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/register`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    deleteStaffUser(id: any) {
        return this.http
            .delete<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/delete/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    viewStaffUsersbyId(id: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/view/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updateStaffpassword(id: any, newPassword: any, confirmPassword: any) {
        const formData = {
            newPassword: newPassword,
            confirmPassword: confirmPassword
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/update-password/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    // roleId '' unassigns the role on the backend (stored as null).
    updateStaff(id: any, name: any, username: any, permissions: any, status: any, roleId: string = '') {
        const formData = {
            name: name,
            username: username,
            permissions: permissions,
            status: status,
            roleId: roleId,
        };
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/update-profile/` +
                id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    // Restaurant Food Categories
    private foodCategoryFormData(name: string, image: File | null, sortOrder: any, status: any) {
        const formData = new FormData();
        formData.append('name', name);
        if (image) formData.append('image', image);
        formData.append('sortOrder', String(sortOrder ?? 0));
        formData.append('status', String(status ?? 1));
        return formData;
    }

    addFoodCategory(name: string, image: File, sortOrder: any, status: any) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/food-category/add`, this.foodCategoryFormData(name, image, sortOrder, status)).pipe(map(user => user));
    }

    getFoodCategoryList(page: any, limit: any = 10, search: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/food-category/list?page=` + page + '&limit=' + limit + '&search=' + encodeURIComponent(search)).pipe(map(user => user));
    }

    foodCategoryDropdown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/food-category/dropdown`).pipe(map(user => user));
    }

    viewFoodCategory(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/food-category/view/` + id).pipe(map(user => user));
    }

    updateFoodCategory(id: any, name: string, image: File | null, sortOrder: any, status: any) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/food-category/update/` + id, this.foodCategoryFormData(name, image, sortOrder, status)).pipe(map(user => user));
    }

    deleteFoodCategory(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/food-category/delete/` + id).pipe(map(user => user));
    }

    // Staff Roles
    getStaffRoles(page: any, search: any, status: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/staff-role/list?page=` + page + '&search=' + search + '&status=' + status).pipe(map(user => user));
    }

    getStaffRoleById(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/staff-role/getById/` + id).pipe(map(user => user));
    }

    createStaffRole(name: string, description: string, permissions: string[]) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/staff-role/create`, { name, description, permissions }).pipe(map(user => user));
    }

    updateStaffRole(id: any, body: { name?: string; description?: string; permissions?: string[]; status?: number }) {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/staff-role/update/` + id, body).pipe(map(user => user));
    }

    deleteStaffRole(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/staff-role/delete/` + id).pipe(map(user => user));
    }

    staffRoleDropdown(search: string = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/staff-role/dropdown?search=` + search).pipe(map(user => user));
    }

    blockStaffUser(id: any, name: any, username: any, status: any) {
        let formData =
        {
            name: name,
            username: username,
            status: status
        }
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/update-profile/` + id, formData)
            .pipe(map((user) => {
                return user;
            }));
    }


    // Excel

    apartmentExcelUpload(file: any,type?: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/apartment/upload?type=`+ type,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadApartmentExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/apartment/download`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }


    LaundryExcelUpload(file: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/laundry/upload`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadLaundryExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/laundry/download`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    RestaurantExcelUpload(file: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/restaurant/upload`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadRestaurantExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/restaurant/download`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    groceryExcelUpload(file: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/grocery/upload`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadGroceryExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/grocery/download`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    carRentalExcelUpload(file: any) {
        const formData = new FormData();
        formData.append("file", file);
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/car-rental/upload`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }

    downloadCarRentalExcel() {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel/car-rental/download`,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    // tax module
    getAllTax(search: any, page: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/tax/list?search=` + search
                + '&page=' + page)
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    getTaxbyId(id: any) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/tax/getById/` +
                id
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    addTax(tax_name: any, tax_value: any, applicable_services: string[]) {
        const formData = {
            tax_name: tax_name,
            tax_value: tax_value,
            applicable_services: applicable_services
        }
        return this.http
            .post<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/tax/create`,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    updateTax(id: any, tax_name: any, tax_value: any, applicable_services: string[]) {
        const formData = {
            tax_name: tax_name,
            tax_value: tax_value,
            applicable_services: applicable_services
        }
        return this.http
            .put<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/tax/update/` + id,
                formData
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
    }
    deleteTax(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/tax/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    // Report
    LaundryReport(page: any, search: any, startDate: any, endDate: any, laundryId: any, categoryId: any, subCategoryId: any, itemId: any,sold:String) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/laundry/list?page=` +
                page +
                "&search=" +
                search +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&laundryId="
                + laundryId +
                "&subCategoryId="
                + subCategoryId +
                "&categoryId="
                + categoryId +
                "&itemId="
                + itemId+
                "&sold=" +
                sold,
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );

    }
    downloadLaundryGenerationExcel(startDate: any, endDate: any, laundryId: any, categoryId: any, subCategoryId: any, itemId: any,sold: String) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/laundry/download?startDate=` +
                startDate +
                "&endDate=" +
                endDate +
                "&laundryId=" +
                laundryId +
                "&categoryId=" +
                categoryId +
                "&subCategoryId="
                + subCategoryId +
                "&itemId="
                + itemId +
                "&sold=" +
                sold,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    RoomServiceReport(page: any, search: any, startDate: any, endDate: any, apartmentId: any, categoryId: any, itemId: any,sold:String) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/room-service/item-report?page=` +
                page +
                "&search=" +
                search +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&apartmentId=" +
                apartmentId +
                "&categoryId=" +
                categoryId +
                "&itemId=" +
                itemId+
                "&sold=" +
                sold
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );

    }
    downloadRoomServiceGenerationExcel(startDate: any, endDate: any, apartmentId: any, categoryId: any, itemId: any,sold:String) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel-reports/room-service/item-report?startDate=` +
                startDate +
                "&endDate=" +
                endDate +
                "&apartmentId=" +
                apartmentId +
                "&categoryId=" +
                categoryId +
                "&itemId="
                + itemId+
                "&sold=" +
                sold,
                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    FoodReportgenerationLists(page: any, search: any, startDate: any, endDate: any, restaurantId: any, categoryId: any, itemId: any,sold: String) {
        return this.http
            .get<any>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/restaurant/list?page=` +
                page +
                "&search=" +
                search +
                "&startDate=" +
                startDate +
                "&endDate=" +
                endDate +
                "&restaurantId=" +
                restaurantId +
                "&categoryId=" +
                categoryId +
                "&itemId=" +
                itemId
                +
                "&sold=" +
                sold
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );

    }
    downloadFoodGenerationExcel(startDate: any, endDate: any, restaurantId: any, categoryId: any, itemId: any, sold: String) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/restaurant/download?startDate=` +
                startDate +
                "&endDate=" +
                endDate +
                "&restaurantId=" +
                restaurantId +
                "&categoryId="
                + categoryId +
                "&itemId="
                + itemId +
                "&sold=" +
                sold,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    // ── Residential Service Report ───────────────────────────────
    getResidentialItemReport(page: number, search: string, startDate: string, endDate: string, apartmentId: string, categoryId: string, itemId: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/item-report?page=${page}&search=${search}&startDate=${startDate}&endDate=${endDate}&apartmentId=${apartmentId}&categoryId=${categoryId}&itemId=${itemId}`);
    }

    getResidentialCategoryDropdown(apartmentId: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/category-dropdown?apartmentId=${apartmentId}`);
    }

    getResidentialItemDropdown(apartmentId: string, categoryId: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/item-dropdown?apartmentId=${apartmentId}&categoryId=${categoryId}`);
    }

    downloadResidentialItemReportExcel(apartmentId: string, categoryId: string, itemId: string, search: string, startDate: string, endDate: string): Observable<Blob> {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/item-report/download?apartmentId=${apartmentId}&categoryId=${categoryId}&itemId=${itemId}&search=${search}&startDate=${startDate}&endDate=${endDate}`, { responseType: 'blob' });
    }

    downloadResidentialCompletedOrdersExcel(apartmentId: string, search: string, startDate: string, endDate: string): Observable<Blob> {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/residential-service/completed-orders/download?apartmentId=${apartmentId}&search=${search}&startDate=${startDate}&endDate=${endDate}`, { responseType: 'blob' });
    }

    // Club Sales Report
    getClubReportTableTypeDropdown(clubId: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/club/table-type-dropdown?clubId=${clubId}`);
    }

    getClubReportEntryTypeDropdown(clubId: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/club/entry-type-dropdown?clubId=${clubId}`);
    }

    getClubSalesSummary(fromDate: string, toDate: string, dateField: string, clubId: string, tableTypeId: string = '', entryModeId: string = ''): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/club/sales/summary?fromDate=${fromDate}&toDate=${toDate}&dateField=${dateField}&clubId=${clubId}&tableTypeId=${tableTypeId}&entryModeId=${entryModeId}`);
    }

    getClubSalesBookings(fromDate: string, toDate: string, dateField: string, clubId: string, page: number, tableTypeId: string = '', entryModeId: string = ''): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/club/sales/bookings?fromDate=${fromDate}&toDate=${toDate}&dateField=${dateField}&clubId=${clubId}&page=${page}&tableTypeId=${tableTypeId}&entryModeId=${entryModeId}`);
    }

    downloadClubSalesExcel(fromDate: string, toDate: string, dateField: string, clubId: string, tableTypeId: string = '', entryModeId: string = ''): Observable<Blob> {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/reports/club/sales/download?fromDate=${fromDate}&toDate=${toDate}&dateField=${dateField}&clubId=${clubId}&tableTypeId=${tableTypeId}&entryModeId=${entryModeId}`, { responseType: 'blob' });
    }

    downloadroomserviceExcel(startDate: any, endDate: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/excel-reports/room-service/item-report?startDate=` +
                startDate +
                "&endDate=" +
                endDate,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }
    downloadlaundrydlvryExcel(startDate: any, endDate: any) {
        const file = this.http
            .get<Blob>(
                `${environment.apiUrl}${environment.apiPrefix}/admin/reports/laundry/download?startDate=` +
                startDate +
                "&endDate=" +
                endDate,

                { responseType: "blob" as "json" }
            )
            .pipe(
                map((user) => {
                    return user;
                })
            );
        return file;
    }

    // FAQ
    getFAQCategoryList(page: any, search: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/category/list?search=` + search + '&page=' + page).pipe(map(user => user));
    }
    deleteFAQCaetgory(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/category/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }
    FAQCAtegroyDropdown() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/category/dropdown`).pipe(map(user => user));
    }
    getFAQCategorylistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/category/getById/${id}`).pipe(map(user => user));
    }
    addFAQCategory(name: any) {
        const formData = new FormData();
        formData.append('name', name);
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/category/create`, formData).pipe(map(user => {
            return user;
        }));
    }
    updateFAQCategory(id: any, name: any, status: any) {
        const formData = new FormData();

        formData.append('name', name);
        formData.append('status', status);

        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/category/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }

    getFAQList(page: any, search: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/list?search=` + search + '&page=' + page).pipe(map(user => user));
    }
    deleteFAQ(id: any) {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/delete/` + id)
            .pipe(map((user) => {
                return user;
            }));
    }

    getFAQlistbyId(id: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/getById/${id}`).pipe(map(user => user));
    }
    addFAQ(categoryId: any, question: any, answer: any) {
        const formData = new FormData();
        formData.append('categoryId', categoryId);
        formData.append('question', question);
        formData.append('answer', answer);

        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/create`, formData).pipe(map(user => {
            return user;
        }));
    }
    updateFAQ(id: any, categoryId: any, question: any, answer: any, status: any) {
        const formData = new FormData();

        formData.append('categoryId', categoryId);
        formData.append('question', question);
        formData.append('answer', answer);
        formData.append('status', status);

        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/faq/update/${id}`, formData).pipe(map(user => {
            return user;
        }));
    }


    sendNotification(message: any, heading: any, image: any, apartmentId: any, targetType?: any, roomNumbers?: any) {
        const formData = new FormData();
        formData.append('message', message);
        formData.append('heading', heading);
        formData.append('targetType', targetType);
        formData.append('roomNos', JSON.stringify(roomNumbers));

        if (image) {
            formData.append('image', image, image.name);
        }
        formData.append('apartmentIds', JSON.stringify(apartmentId));

        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/notification/send`, formData).pipe(map(user => {
            return user;
        }));
    }

    getNotification(page: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/notification/list?page=` + page).pipe(map(user => user));
    }

    getApartmentItemDropdown(apartmentId: any, categoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/item-dropdown?apartmentId=` + apartmentId + "&categoryId=" + categoryId).pipe(map(user => user));
    }
    getFoodCategoryDropdown(restaurantId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/category-dropdown?restaurantId=` + restaurantId).pipe(map(user => user));
    }
    getFoodItemDropdown(restaurantId: any, categoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/item-dropdown?restaurantId=` + restaurantId + "&categoryId=" + categoryId).pipe(map(user => user));
    }

    getLaundryCategoryDropdown(laundryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/category-dropdown?laundryId=` + laundryId).pipe(map(user => user));
    }
    getLaundrySubCategoryDropdown(laundryId: any, categoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/subcategory-dropdown?laundryId=` + laundryId + "&categoryId=" + categoryId).pipe(map(user => user));
    }
    getlaundryItemDropdown(laundryId: any, categoryId: any, subCategoryId: any) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/laundry/item-dropdown?laundryId=` + laundryId + "&categoryId=" + categoryId + "&subCategoryId=" + subCategoryId).pipe(map(user => user));
    }

    AdminsendNotification(message: any, heading: any, user_type: any, is_web: any, user_ids: any) {
        const payload = {
            heading: heading,
            message: message,
            user_type: user_type,
            is_web: is_web,
            user_ids: user_ids
        };

        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/notification/sendWeb`, payload).pipe(map(user => {
            return user;
        }));
    }

    //wallet
    getWalletCount() {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/count`);
    }

    getWalletList(page: number, search = '', apartmentId = '', fromDate = '', toDate = '') {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/wallet/list?page=${page}&userName=${search}`;
        if (apartmentId) url += `&apartmentId=${apartmentId}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;
        return this.http.get<any>(url);
    }

    getWalletTransactionsByUser(userId: string, page = 1) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/list-by-user/${userId}?page=${page}`);
    }

    getRefundedList(page: number, search = '', fromDate: any, toDate: any, apartmentId: any,){
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/refunded-list?page=${page}&userName=${search}&fromDate=${fromDate}&toDate=${toDate}&apartmentName=${apartmentId}`);
    }

    refund(amount: any, date: any, time: any, transactionId: string, description: string, customerAccountNumber: string, userId: any) {
        const formdata = new FormData();

        formdata.append('amount', amount);
        formdata.append('date', date);
        formdata.append('time', time);
        formdata.append('transactionId', transactionId);
        formdata.append('description', description);
        formdata.append('customerAccountNumber', customerAccountNumber);

        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/settle/${userId}`, formdata)
    }

    getUnitsByApartment(apartmentId: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/apartment/units?apartmentId=${apartmentId}`);
    }

    getWalletApartmentList(search = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/apartment-list?search=${search}`);
    }

    getBuildingsByApartment(apartmentId: string, search = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/building-list/${apartmentId}?search=${search}`);
    }

    getUnitsByBuilding(buildingId: string, search = '') {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/unit-list/${buildingId}?search=${search}`);
    }

    getUsersByBuilding(buildingId: string) {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/user-list?buildingId=${buildingId}`);
    }

    getRechargeHistory(page: number, userName = '', apartmentId = '', fromDate = '', toDate = '') {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/wallet/recharge-history?page=${page}&userName=${userName}&apartmentId=${apartmentId}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;
        return this.http.get<any>(url);
    }

    downloadWalletTransactionsExcel(apartmentId = '', fromDate = '', toDate = ''): Observable<Blob> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/wallet/transactions/excel?`;
        const parts: string[] = [];
        if (apartmentId) parts.push(`apartmentId=${apartmentId}`);
        if (fromDate) parts.push(`fromDate=${fromDate}`);
        if (toDate) parts.push(`toDate=${toDate}`);
        url += parts.join('&');
        return this.http.get(url, { responseType: 'blob' });
    }

    downloadRechargeHistoryExcel(userName = '', apartmentId = '', fromDate = '', toDate = ''): Observable<Blob> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/wallet/recharge-history/excel?`;
        const parts: string[] = [];
        if (userName) parts.push(`userName=${userName}`);
        if (apartmentId) parts.push(`apartmentId=${apartmentId}`);
        if (fromDate) parts.push(`fromDate=${fromDate}`);
        if (toDate) parts.push(`toDate=${toDate}`);
        url += parts.join('&');
        return this.http.get(url, { responseType: 'blob' });
    }

    rechargeWalletByProperty(apartmentIds: string[], amount: number, description: string) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/add-credit`, { apartmentIds, amount, description });
    }

    rechargeWalletByResident(userIds: string[], amount: number, description: string) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/wallet/add-credit`, { userIds, amount, description });
    }

    //rating
    getRatingStructureList(page: any, orderType: string, search: string): Observable<any> {
        return this.http.get(
            `${environment.apiUrl}${environment.apiPrefix}/admin/rating-structure/list?page=${page}&orderType=${orderType}&search=${search}`
        );
    }
    createRatingStructure(payload: {
        orderType: string;
        question: string;
        type: string;
        options?: string[];
        order: number;
    }): Observable<any> {
        return this.http.post(`${environment.apiUrl}${environment.apiPrefix}/admin/rating-structure/create`, payload);
    }

    updateRatingStructure(id: string, payload: {
        orderType: string;
        question: string;
        type: string;
        options?: string[];
        order: number;
    }): Observable<any> {
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/rating-structure/update/${id}`, payload);
    }

    updateRatingStructureStatus(id: string, status: number): Observable<any> {
        return this.http.put(`${environment.apiUrl}${environment.apiPrefix}/admin/rating-structure/update-status/${id}`, { status });
    }

    getConversationRatingsList(page: number, rating: string, apartmentId: string): Observable<any> {
        return this.http.get(
            `${environment.apiUrl}${environment.apiPrefix}/admin/conversation-ratings/list?page=${page}&rating=${rating}&apartmentId=${apartmentId}`
        );
    }

    getElevenLabsConversation(conversationId: string): Observable<any> {
        return this.http.get(
            `${environment.apiUrl}${environment.apiPrefix}/admin/elevenlabs/conversation/${conversationId}`
        );
    }

    getUserRatingsList(page: number, orderType: string, rating: string = ''): Observable<any> {
        return this.http.get(
            `${environment.apiUrl}${environment.apiPrefix}/admin/rating-structure/rating-list?page=${page}&orderType=${orderType}&deliveryRating=${rating}`
        );
    }

    // User Help Templates
    getUserHelpTemplateList(page: number, status: string, search: string): Observable<any> {
        return this.http.get(
            `${environment.apiUrl}${environment.apiPrefix}/admin/user-help-template/list?page=${page}&status=${status}&search=${search}`
        );
    }

    createUserHelpTemplate(payload: { title: string; description: string; category: string; escalationTimeMinutes: number }): Observable<any> {
        return this.http.post(
            `${environment.apiUrl}${environment.apiPrefix}/admin/user-help-template/create`,
            payload
        );
    }

    updateUserHelpTemplate(id: string, payload: { title: string; description: string; category: string; escalationTimeMinutes?: number; status?: number }): Observable<any> {
        return this.http.put(
            `${environment.apiUrl}${environment.apiPrefix}/admin/user-help-template/update/${id}`,
            payload
        );
    }

    deleteUserHelpTemplate(id: string): Observable<any> {
        return this.http.delete(
            `${environment.apiUrl}${environment.apiPrefix}/admin/user-help-template/delete/${id}`
        );
    }

    getUserHelpTemplateById(id: string): Observable<any> {
        return this.http.get(
            `${environment.apiUrl}${environment.apiPrefix}/admin/user-help-template/getById/${id}`
        );
    }

    // Audit Logs
    getAuditLogs(page: number, fromDate: string, toDate: string, search: string, category: string): Observable<any> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/audit-logs/list?page=${page}&limit=20`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;
        if (search) url += `&search=${search}`;
        if (category) url += `&category=${category}`;
        return this.http.get<any>(url);
    }

    // Admin Logs (activity of apartment admins)
    getAdminLogs(page: number, fromDate: string, toDate: string, search: string, category: string, apartmentId: string): Observable<any> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/audit-logs/apartment-admin-list?page=${page}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        if (category) url += `&category=${category}`;
        if (apartmentId) url += `&apartmentId=${apartmentId}`;
        return this.http.get<any>(url);
    }

    getAdminLogsCount(apartmentId: string = ''): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/audit-logs/apartment-admin-count?apartmentId=${apartmentId}`);
    }

    getAuditLogsCount(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/audit-logs/count`);
    }

    getPlatformHealth(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/audit-logs/platform-health`);
    }

    payVendorSettlement(payload: { vendorId: string; vendorType: string; fromDate: string; toDate: string; periodType: string; paidStatus: number }): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/pay`, payload);
    }

    getVendorSettlementFormulaSheet(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/formula-sheet`);
    }

    getVendorSettlementVendors(vendorType: string, page: number, search: string): Observable<any> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/vendors?page=${page}&limit=20`;
        if (vendorType) url += `&vendorType=${vendorType}`;
        if (search) url += `&search=${search}`;
        return this.http.get<any>(url);
    }

    getVendorSettlementSummary(params: {
        fromDate?: string;
        toDate?: string;
        periodType?: string;
        vendorType?: string;
        vendorId?: string;
        status?: string;
        search?: string;
    }): Observable<any> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/summary?`;
        if (params.fromDate) url += `fromDate=${params.fromDate}&`;
        if (params.toDate) url += `toDate=${params.toDate}&`;
        if (params.periodType) url += `periodType=${params.periodType}&`;
        if (params.vendorType) url += `vendorType=${params.vendorType}&`;
        if (params.vendorId) url += `vendorId=${params.vendorId}&`;
        if (params.status) url += `status=${params.status}&`;
        if (params.search) url += `search=${params.search}&`;
        return this.http.get<any>(url);
    }

    getVendorSettlementList(params: {
        fromDate?: string;
        toDate?: string;
        periodType?: string;
        vendorType?: string;
        vendorId?: string;
        status?: string;
        search?: string;
        page?: number;
        limit?: number;
    }): Observable<any> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/list?page=${params.page || 1}&limit=${params.limit || 200}`;
        if (params.fromDate) url += `&fromDate=${params.fromDate}`;
        if (params.toDate) url += `&toDate=${params.toDate}`;
        if (params.periodType) url += `&periodType=${params.periodType}`;
        if (params.vendorType) url += `&vendorType=${params.vendorType}`;
        if (params.vendorId) url += `&vendorId=${params.vendorId}`;
        if (params.status) url += `&status=${params.status}`;
        if (params.search) url += `&search=${params.search}`;
        return this.http.get<any>(url);
    }

    getVendorSettlementDetail(vendorType: string, vendorId: string, fromDate: string, toDate: string): Observable<any> {
        return this.http.get<any>(
            `${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/detail/${vendorType}/${vendorId}?fromDate=${fromDate}&toDate=${toDate}`
        );
    }

    exportVendorSettlementExcel(params: {
        fromDate?: string;
        toDate?: string;
        periodType?: string;
        vendorType?: string;
        vendorId?: string;
        status?: string;
        search?: string;
    }): Observable<Blob> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/export/excel?`;
        if (params.fromDate) url += `fromDate=${params.fromDate}&`;
        if (params.toDate) url += `toDate=${params.toDate}&`;
        if (params.periodType) url += `periodType=${params.periodType}&`;
        if (params.vendorType) url += `vendorType=${params.vendorType}&`;
        if (params.vendorId) url += `vendorId=${params.vendorId}&`;
        if (params.status) url += `status=${params.status}&`;
        if (params.search) url += `search=${params.search}&`;
        return this.http.get(url, { responseType: 'blob' });
    }

    exportVendorSettlementCsv(params: {
        fromDate?: string;
        toDate?: string;
        periodType?: string;
        vendorType?: string;
        vendorId?: string;
        status?: string;
        search?: string;
    }): Observable<Blob> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/vendor-settlements/export/csv?`;
        if (params.fromDate) url += `fromDate=${params.fromDate}&`;
        if (params.toDate) url += `toDate=${params.toDate}&`;
        if (params.periodType) url += `periodType=${params.periodType}&`;
        if (params.vendorType) url += `vendorType=${params.vendorType}&`;
        if (params.vendorId) url += `vendorId=${params.vendorId}&`;
        if (params.status) url += `status=${params.status}&`;
        if (params.search) url += `search=${params.search}&`;
        return this.http.get(url, { responseType: 'blob' });
    }

    // ── Coupon ──────────────────────────────────────────────────
    getCouponApartmentDropdown(establishmentId: string, module: string, search: string = ''): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/coupon/apartments-dropdown?search=${search}&module=${module}&establishment_id=${establishmentId}`);
    }

    getApartmentCouponList(page: number, search: string, status: string, fromDate: string = '', toDate: string = '', orderType: string = ''): Observable<any> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/coupon/list?page=${page}&search=${search}&status=${status}`;
        if (fromDate) url += `&from=${fromDate}`;
        if (toDate) url += `&to=${toDate}`;
        if (orderType) url += `&module=${orderType}`;
        return this.http.get<any>(url);
    }

    downloadCouponUsageReport(params: { from?: string; to?: string; order_type?: string; coupon_id?: string; search?: string; status?: string }): Observable<Blob> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/coupon/usage-report?`;
        const parts: string[] = [];
        if (params.from) parts.push(`from=${params.from}`);
        if (params.to) parts.push(`to=${params.to}`);
        if (params.order_type) parts.push(`order_type=${params.order_type}`);
        if (params.coupon_id) parts.push(`coupon_id=${params.coupon_id}`);
        if (params.search) parts.push(`search=${params.search}`);
        if (params.status) parts.push(`status=${params.status}`);
        url += parts.join('&');
        return this.http.get(url, { responseType: 'blob' });
    }
    createApartmentCoupon(data: any): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/coupon/create`, data);
    }
    getApartmentCouponById(id: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/coupon/getById/${id}`);
    }
    updateApartmentCoupon(id: string, data: any): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/coupon/update/${id}`, data);
    }
    deleteApartmentCoupon(id: string): Observable<any> {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/coupon/delete/${id}`);
    }
    updateApartmentCouponStatus(id: string, status: number): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/coupon/update-status/${id}`, { status });
    }

    // ── Translations ────────────────────────────────────────────
    getTranslationList(search: string = '', page: number = 1): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/translation/list?search=${search}&page=${page}`);
    }
    createTranslation(data: { key: string; translations: { en: string; ar: string } }): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/translation/create`, data);
    }
    // key is immutable once created — only translations/status can change.
    updateTranslation(id: string, data: { translations: { en: string; ar: string }; status: number }): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/translation/update/${id}`, data);
    }
    downloadTranslationExcel(): Observable<Blob> {
        return this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/translation/excel/download`, { responseType: "blob" as "json" });
    }
    translationExcelUpload(file: any): Observable<any> {
        const formData = new FormData();
        formData.append("file", file);
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/translation/excel/upload`, formData);
    }

    // ── Owner ───────────────────────────────────────────────────
    getOwnerList(search: string = '', page: number = 1): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/owner/list?search=${search}&page=${page}`);
    }
    getOwnerById(id: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/owner/getById/${id}`);
    }
    getOwnerDropdown(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/owner/dropdown`);
    }
    createOwner(data: any): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/owner/add`, data);
    }
    updateOwner(id: string, data: any): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/owner/update/${id}`, data);
    }
    updateOwnerPassword(id: string, newPassword: string, confirmPassword: string): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/owner/update-password/${id}`, { newPassword, confirmPassword });
    }
    deleteOwner(id: string): Observable<any> {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/owner/delete/${id}`);
    }

    getRestaurantSlaList(slaStatus: string = '', page: number = 1, limit: number = 10, apartmentId: string = '', restaurantId: string = '', fromDate: string = '', toDate: string = '', orderStatus: string = ''): Observable<any> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/orders/restaurant/sla-list?page=${page}&limit=${limit}`;
        if (slaStatus) url += `&slaStatus=${slaStatus}`;
        if (apartmentId) url += `&apartmentId=${apartmentId}`;
        if (restaurantId) url += `&restaurant_id=${restaurantId}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;
        if (orderStatus !== '') url += `&orderStatus=${orderStatus}`;
        return this.http.get<any>(url);
    }

    getRestaurantOrderList(slaStatus: string = '', page: number = 1, limit: number = 10, apartmentId: string = '', restaurantId: string = '', fromDate: string = '', toDate: string = '', orderStatus: string = '', type: string = ''): Observable<any> {
        let url = `${environment.apiUrl}${environment.apiPrefix}/admin/orders/restaurant/pending-stale?page=${page}&limit=${limit}`;
        if (slaStatus) url += `&slaStatus=${slaStatus}`;
        if (apartmentId) url += `&apartmentId=${apartmentId}`;
        if (restaurantId) url += `&restaurant_id=${restaurantId}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;
        if (orderStatus !== '') url += `&orderStatus=${orderStatus}`;
        if (type) url += `&type=${type}`;
        return this.http.get<any>(url);
    }

    createOnboardingInvite(payload: any): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/invite`, payload);
    }

    getOnboardingList(params: { page: number; limit: number; search?: string; status?: string; vendorType?: string; days?: string }): Observable<any> {
        let httpParams = new HttpParams().set('page', params.page).set('limit', params.limit);
        if (params.search) httpParams = httpParams.set('search', params.search);
        if (params.status) httpParams = httpParams.set('status', params.status);
        if (params.vendorType) httpParams = httpParams.set('vendorType', params.vendorType);
        if (params.days) httpParams = httpParams.set('days', params.days);
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/list`, { params: httpParams });
    }

    getOnboardingApplication(applicationId: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/view/${applicationId}`);
    }

    downloadOnboardingDocument(applicationId: string, docId: string): Observable<Blob> {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/document/${applicationId}/${docId}`, { responseType: 'blob' });
    }

    downloadOnboardingAgreement(applicationId: string): Observable<Blob> {
        return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/agreement-pdf/${applicationId}`, { responseType: 'blob' });
    }

    updateOnboardingApplication(applicationId: string, payload: any): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/update/${applicationId}`, payload);
    }

    resendOnboardingInvite(applicationId: string, payload: any = {}): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/resend/${applicationId}`, payload);
    }

    regenerateOnboardingInvite(applicationId: string, payload: any = {}): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/regenerate/${applicationId}`, payload);
    }

    revokeOnboardingInvite(applicationId: string): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/revoke/${applicationId}`, {});
    }

    deleteOnboardingApplication(applicationId: string): Observable<any> {
        return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/delete/${applicationId}`);
    }

    // The backend asks the Support Panel for a one-time SSO code; the secret key never reaches the browser.
    openSupportPanel(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/support-panel/open`);
    }

    approveOnboardingApplication(applicationId: string, payload: any = {}): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/approve/${applicationId}`, payload);
    }

    rejectOnboardingApplication(applicationId: string, payload: { reason: string; message?: string }): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/reject/${applicationId}`, payload);
    }

    requestOnboardingCorrection(applicationId: string, payload: any): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/onboarding/request-correction/${applicationId}`, payload);
    }
}
